var inArray = require('in-array');


   /**
     * Проверяет принадлежит ли объекту свойство
     *
     * @param {{}} obj Объект
     * @param {string} property Свойство
     * @returns {boolean}
     */
    function hasOwn(obj, property) {
        return obj.hasOwnProperty(property);
    }


     /**
     * Преобразует запрос из формата принятого в плагине в формат сервиса
     *
     * @param {{}} query Запрос в формате плагина
     * @returns {{}} Запрос в формате сервиса
     */
    function toApiFormat(query) {
        var params = {},
            fields = {
                type: 'contentType',
                name: 'query',
                withParents: 'withParent'
            };

        if (query.parentType && query.parentId) {
            params[query.parentType + 'Id'] = query.parentId;
        }

        for (var key in query) {
            if (hasOwn(query, key) && query[key]) {
                params[hasOwn(fields, key) ? fields[key] : key] = query[key];
            }
        }

        return params;
    }


class Fias{

    static  get protocol() {return 'https:'}
    static  get url(){ return  Fias.protocol + '//kladr-api.com/api.php'}
    static  get timeout(){return  3000}

    static  get type(){
        return {
        region: 'region',   // Область
        district: 'district', // Район
        city: 'city',     // Город
        street: 'street',   // Улица
        building: 'building',  // Строение
        zip: 'zip'
    }}


    static  get parents(){return [
        'zip',
        'building',  // Строение
        'street',   // Улица
        'city',     // Город
        'district', // Район
        'region'   // Область
    ]}

    

    static  get typeCode(){ return  {
        city: 1, // Город
        settlement: 2, // Посёлок
        village: 4  // Деревня
    }}

    constructor(token){
        this.token = token
        
    }



    validate(query) {
        

        switch (query.type) {
            case Fias.type.region:
            case Fias.type.district:
            case Fias.type.city:
                if (query.parentType && !query.parentId) {
                    this.error('parentId undefined');
                    return false;
                }
                break;
            case Fias.type.street:

                if (query.parentType != Fias.type.city && query.parentType != Fias.type.street) {
                    this.error('parentType must equal "city" or "street"');
                    return false;
                }
                if (!query.parentId) {
                    this.error('parentId undefined');
                    return false;
                }
                break;
            case Fias.type.building:
                if (!query.zip) {
                    if (!~inArray(query.parentType, [Fias.type.street, Fias.type.city])) {
                        this.error('parentType must equal "street" or "city"');
                        return false;
                    }
                    if (!query.parentId) {
                        this.error('parentId undefined');
                        return false;
                    }
                }
                break;
            default:
                if (!query.oneString) {
                    this.error('type incorrect');
                    return false;
                }
                break;
        }

        if (query.oneString && query.parentType && !query.parentId) {
            this.error('parentId undefined');
            return false;
        }

        if (query.typeCode && (query.type != Fias.type.city)) {
            this.error('type must equal "city"');
            return false;
        }

        if (query.limit < 1) {
            this.error('limit must greater than 0');
            return false;
        }

        return true;
    }


    error(str){
        console.error(str, this);
    }

  
    /**
     * Отправляет запрос к сервису
     *
     * @param {{}} query Запрос
     * @param {Function} callback Функция, которой будет передан массив полученных объектов
     */
    api (query, callback) {
        if (!callback) {
            this.error('Callback undefined');
            return;
        }

        if (!this.validate(query)) {
            callback.reject([]);
            return;
        }


     

        if(!query.token && Fias.token) {
            query.token = Fias.token;
        }


        var a = $.ajax({
            url: Fias.url + '?callback=?',
            type: 'get',
            data: toApiFormat(query),
            dataType: 'jsonp'
        });


        a.done(function (data) {

            callback.resolve(data.result || []);
            
        });


    }

    //$.fias.api = debounce($.fias.api, 250);

    /**
     * Проверяет существование объекта, соответствующего запросу
     *
     * @param {{}} query Запрос
     * @param {Function} callback Функция, которой будет передан объект, если он существует, или
     * false если не существует.
     */
    check(query, callback) {
        if (!callback) {
            this.error('Callback undefined');
            return;
        }

        query.withParents = false;
        query.limit = 1;

        this.api(query, callback);
    }


}



export { Fias};



// WEBPACK FOOTER //
// ./src/core/kladr.js